import { useEffect } from 'react';
import { api } from 'src/services';
import { AppLoader } from 'src/components/AppLoader';

export const DocuSignReturnHandler = () => {
  useEffect(() => {
    let event: string | null = null;
    try {
      const params = new URLSearchParams(window.location.search);
      event = params.get('event');
    } catch {
      console.error('Error parsing URL search params');
      window.location.replace('/');
      return;
    }

    const runCallback = async () => {
      try {
        await api.post('/v2/ds/envelope/callback', { event });
      } catch (e) {
        console.error('Error running docusign callback', e);
      } finally {
        window.location.replace('/');
      }
    };

    runCallback();
  }, []);

  return <AppLoader loaderText="Please wait while we redirect you..." />;
};
